const assetGroupTypePaths = {
    'Collection': 'collections',
    'Lightbox': 'projects',
    'StorageFolder': 'folders',
}

export const currentAssetGroupRefreshId = currentAssetGroup =>
    currentAssetGroup?.folder?.id || currentAssetGroup?.asset_group_id || currentAssetGroup?.id

export const assetGroupFindIdentifier = ({
    currentAssetGroup,
    currentAssetGroupReloadId,
    routeType,
    routeSlug,
}) => {
    const rootId = currentAssetGroup?.asset_group_id || currentAssetGroup?.id
    const activeId = currentAssetGroupRefreshId(currentAssetGroup)
    const canReloadById =
        currentAssetGroupReloadId &&
        String(currentAssetGroupReloadId) === String(activeId) &&
        assetGroupTypePaths[currentAssetGroup?.type] === routeType &&
        currentAssetGroup?.slug === routeSlug

    if (!canReloadById) return `slug=${encodeURIComponent(routeSlug)}`

    const identifier = `id=${encodeURIComponent(rootId)}`
    return currentAssetGroup?.folder?.id ?
        `${identifier}&folder_id=${encodeURIComponent(currentAssetGroupReloadId)}` :
        identifier
}

export const canonicalAssetGroupPath = ({assetGroup, folder, organizationSlug}) => {
    const routeType = assetGroupTypePaths[assetGroup?.type]
    if (!routeType || !assetGroup?.slug) return null

    const base = organizationSlug
        ? `/explore/shared-libraries/${organizationSlug}`
        : `/explore/${routeType}`
    const slug = assetGroup.folder?.slug || `${assetGroup.slug}${folder ? `/${folder}` : ''}`
    return `${base}/${slug}`
}
